import React, { useState, useContext } from 'react';
import Context from "../context/context";

const Search = props => {
  const {data} = props;
  const {activeFilters, setActiveFilters} = useContext(Context);
  // const [value, setValue] = useState(activeFilters.search.value);
  let searchValue = activeFilters.search.value;

  const updateSearch = (val) => {
    searchValue = val;
    const search = {...activeFilters.search};
    search.value = val;
    setActiveFilters({...activeFilters,
      search
    });

  }

  return (
    <div className="search">
        <label htmlFor={data.name}>Search</label>
        <div className="input-wrapper">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
        <path d="M9.36515 16.1749C13.1265 16.1749 16.1756 13.1257 16.1756 9.36442C16.1756 5.6031 13.1265 2.55396 9.36515 2.55396C5.60384 2.55396 2.55469 5.6031 2.55469 9.36442C2.55469 13.1257 5.60384 16.1749 9.36515 16.1749Z" stroke="#2D2D2C" stroke-width="1.70262" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M17.8751 17.8775L14.1719 14.1743" stroke="#2D2D2C" stroke-width="1.70262" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <input
            type="search"
            name={data.name}
            placeholder={data.title}
            value={searchValue}
            onChange={(e) => updateSearch(e.target.value)}
        />
        </div>
        <span className="sr-only">{data.title}</span>

    </div>
  )
}

export default Search;
